module.exports = __webpack_public_path__ + "img/jioayun.30e84a73.png";